import * as React from "react";
import { PageHeader, Divider, Button } from "antd";
import { EditTwoTone, FileTextTwoTone, ToolTwoTone } from "@ant-design/icons";

// common
import { ShareFacebook, ShareTwitter } from "../common";

const AboutPage = () => {
  return (
    <>
      <PageHeader
        title="このサイトについて"
        extra={[<ShareFacebook />, <ShareTwitter />]}
      />
      <div style={{ padding: 24, paddingTop: 0 }}>
        <p>
          CyTrainは一般インターネット利用者向けのオンラインセキュリティ講座です。
          「インターネットは日常に欠かせない世の中なのに、なぜ一般利用者がセキュリティ学べる場がこんなにも少ないのだろう？」という一つの疑問から開発を進めてきました。
          今までセキュリティ講座といえば開発者向けのものが多く存在してきましたが、一般ユーザーがオンライン上の脅威から身を守るための知識はあまり共有されていません。
          この講座を機に、すべての人ができる限りのセキュリティ対策と当事者意識をもって少しでもサイバー犯罪を減らせるよう願っています。
        </p>
        <Divider orientation="left">
          <EditTwoTone /> アンケートご協力のお願い
        </Divider>
        <p>
          CyTrainは開発者の卒論と未来のより良いオンラインセキュリティ講座のために
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfGjPuggfBKq-wmqTBkhYV1lpAA9vKfPtjiLFljBxXaHeeasA/viewform?usp=sf_link"
            target="_blank"
            rel="noreferrer"
          >
            Google Forms
          </a>
          にてフィードバックを集めています。あなたのご感想やご意見が励みになります。ご協力よろしくお願いいたします。
          <br />
          <br />
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfGjPuggfBKq-wmqTBkhYV1lpAA9vKfPtjiLFljBxXaHeeasA/viewform?usp=sf_link"
            target="_blank"
            rel="noreferrer"
          >
            <Button type="primary" block danger>
              アンケートに協力する
            </Button>
          </a>
        </p>
        <Divider orientation="left">
          <FileTextTwoTone /> 参考資料
        </Divider>
        <p>
          この講座を作る上で参考にした資料は以下の通りです。リンクをクリックすると外部サイトに遷移します。
        </p>
        <ul>
          <li>
            <a
              href="https://www.nisc.go.jp/security-site/handbook/index.html"
              target="_blank"
              rel="noreferrer"
            >
              インターネットの安全・安心ハンドブックVer 4.10（令和2年4月20日）
              ／ 内閣サイバーセキュリティセンター（NISC）
            </a>
          </li>
          <li>
            <a
              href="https://www.soumu.go.jp/main_sosiki/joho_tsusin/security/enduser/index.html"
              target="_blank"
              rel="noreferrer"
            >
              国民のための情報セキュリティサイト　一般利用者の対策 ／ 総務相
            </a>
          </li>
          <li>
            <a
              href="https://www.ipa.go.jp/security/vuln/10threats2021.html"
              target="_blank"
              rel="noreferrer"
            >
              情報セキュリティ 10 大脅威 2021 ／
              独立行政法人情報処理推進機構（IPA）
            </a>
          </li>
          <li>
            <a
              href="https://japan.norton.com/"
              target="_blank"
              rel="noreferrer"
            >
              ノートン ブログ ／ Norton
            </a>
          </li>
        </ul>
        <Divider orientation="left">
          <ToolTwoTone /> 開発とデータ
        </Divider>
        <p>
          このサイトはすべての利用者が安全に利用できるように、個人情報などのデータを一切取り扱いません。
          また開発時に手動でテストされていますが、万が一進行不能など致命的なバグがある場合は
          <a href="mailto:shayma@ttu.ee">開発者</a>までご連絡ください。
        </p>
        <p>
          レスポンシブに対応していますが、どちらかというとモバイル・ファーストなデザインになっています。
          選択肢があるのであれば、出来る限りスマホまたは小型タブレットを使用するとスムーズに進みます。
          開発の時間が足りませんでした。ご迷惑おかけします。
        </p>
      </div>
    </>
  );
};

export default AboutPage;
